<template>
  <div class="medicalCare">
    <div class="title row-title">
      <p>长者姓名:</p>
      <el-input
        type="text"
        v-model="oldName"
        clearable
        style="width: 200px; margin-right: 10px"
        @keyup.enter.native.prevent="enterSearchMember"
      ></el-input>
      <p>老人身份证号:</p>
      <el-input
        type="text"
        v-model="idCard"
        clearable
        style="width: 200px; margin-right: 10px"
        @keyup.enter.native.prevent="enterSearchMember"
      ></el-input>
      <p>{{ medicalCare.examinationData + ":" }}</p>
      <el-date-picker
        v-model="examinationTime"
        type="date"
        :placeholder="medicalCare.choseTime"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        clearable
      ></el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        plain
        @click="getexaminationRecord"
        style="margin-left: 20px"
        >查询</el-button
      >
      <el-button type="warning" icon="el-icon-plus" @click="detailAdd" plain>新增</el-button>
    </div>
    <div class="personTable">
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 2px;min-height:500px"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
      >
        <el-table-column
          prop="oldName"
          :label="medicalCare.name"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldIdCard"
          label="身份证号"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sex"
          :label="medicalCare.sex"
          width="66"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldAge"
          :label="medicalCare.old"
          width="66"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="height"
          :label="medicalCare.height"
          width="66"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="weight"
          :label="medicalCare.weight"
          width="66"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="dbp"
          :label="medicalCare.DBS"
          width="75"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sbp"
          :label="medicalCare.SBS"
          width="75"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="examineResult"
          :label="medicalCare.result"
          width="300"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="examineTime"
          :label="medicalCare.time"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="examinePhoto"
          :label="medicalCare.photo"
          width="85"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              size="mini"
              @click="queryPic(scope.row)"
              >{{ medicalCare.look }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="option"
          label="操作"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              class="el-icon-edit-outline"
              style="font-size: 25px"
              @click="fixAdd(scope.row)"
            ></el-button> -->
             <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="fixAdd(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :title="medicalCare.queryPic"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      width="580px"
    >
      <span class="dialog-body">
        <div v-for="item in url" :key="item">
          <el-image
            style="width: 500px; height: 200px; margin-left: 10px"
            :src="item"
            :preview-src-list="[item]"
          ></el-image>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <!-- 翻页 -->
    <div class="page">
      <el-pagination
        class="fenye"
        background
        layout="total,prev, pager, next"
        :total="Number(examinationrecord.total)"
        @current-change="handleCurrentChange"
        align="center"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";
export default {
  name: "MedicalCare",
  data() {
    return {
      medicalCare:  {
  examinationData: "体检日期",
  choseTime: "选择日期",
  name: "姓名",
  sex: "性别",
  old: "年龄",
  height: "身高",
  weight: "体重",
  DBS: "舒张压",
  SBS: "收缩压",
  result: "体检结果",
  time: "体检时间",
  photo: "体检截图",
  look: "查看",
  queryPic: "查看图片",
  back: "返回"
}, //引入中文字符
      tableData: [], //表格数据
      examinationrecord: [], //体检数据
      oldName: "", //input框老人姓名
      idCard: "", //input框老人身份证号
      examinationTime: "", //input框体检时间
      pageNo: "1", //页码
      dialogVisible: false, //弹窗状态
      url: [], //图片地址
    };
  },
  mounted() {
    this.getexaminationRecord();
    //添加详情后刷新页面
    bus.$on("changepage", (item) => {
      if (item) {
        this.getexaminationRecord();
      }
    });
  },
  methods: {
     //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //enter查询
    enterSearchMember() {
      this.getexaminationRecord();
    },
    //获取体检信息
    getexaminationRecord() {
      let param = {
        name: this.oldName,
        idCard: this.idCard,
        examinetime: this.examinationTime,
        pageNo: this.pageNo,
        pageSize: "10",
      };
      this.$postJson("omc/Examine/selExamineRecord", param).then((res) => {
        console.log(res);
        let medicalCareDetail = res.result.list;
        var maps = new Map([
          [0, "男"],
          [1, "女"],
        ]);
        this.tableData = medicalCareDetail.map((element) => {
          element.sex = maps.get(element.sex);
          return element;
        });
        this.examinationrecord = res.result;
      });
    },

    //翻页
    handleCurrentChange(e) {
      this.pageNo = String(e);
      this.getexaminationRecord();
    },
    //添加体检记录
    detailAdd() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/examinationDetailAdd",
        title: "体检详情",
      });
    },

    //修改体检记录
    fixAdd(row) {
      bus.$emit("homePage", {
        type: "jump",
        path: "/examinationDetailAdd",
        title: "体检详情",
      });
      setTimeout(function () {
        bus.$emit("examinationFix", row);
      }, 100);
    },

    //查询体检截图
    queryPic(row) {
      this.dialogVisible = true;
      let ids = row.examinePhoto.split(";");
      let urls = [];
      for (var i = 0; i < ids.length; i++) {
        urls.push(ids[i]);
      }
      this.url = urls;
    },
  },
};
</script>

<style  lang="scss" scoped>
.medicalCare {
  .title {
    display: flex;
    align-items: center;
        padding: 10px;
    input {
      height: 38px;
      width: 212px;
      border-radius: 4px;
      border: 1px solid #e2e2e2;
      margin-right: 10px;
    }
  }
  .page {
    margin-top: 20px;
  }
}
.fenye {
  padding: 30px 0;background: #fff;
}
</style>